module.exports = __webpack_public_path__ + "img/N134-2.4a279110.png";